module.exports = __webpack_public_path__ + "static/media/el-GR.3a147302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/el-GR.png
// module id = 939
// module chunks = 0